export default __webpack_public_path__ + "static/media/lackier_job_details.259fe626.png";